import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconLabel(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19ZM5 7h11l3.55 5L16 17H5V7Zm11.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
        clipRule="evenodd"
      />
    </BaseIcon>
  );
}
